function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M6.911 20h4.286v-7.535c0-.472.051-.835.154-1.091.18-.458.454-.845.82-1.162.368-.316.828-.475 1.381-.475 1.442 0 2.162 1.017 2.162 3.05V20H20v-7.737c0-1.994-.45-3.505-1.351-4.536-.901-1.03-2.092-1.545-3.572-1.545-1.66 0-2.953.747-3.88 2.242v.04h-.02l.02-.04V6.505H6.91c.026.431.039 1.771.039 4.02 0 2.25-.013 5.408-.039 9.475zm-6.66 0h4.286V6.505H.25V20zM0 2.323C0 1.65.225 1.094.676.657 1.126.219 1.712 0 2.432 0c.708 0 1.281.215 1.719.646.45.445.675 1.024.675 1.738 0 .646-.219 1.185-.656 1.616-.45.444-1.043.667-1.776.667h-.02c-.707 0-1.28-.223-1.718-.667C.22 3.556 0 2.997 0 2.323z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin-white.d31b974d.svg";
export { SvgComponent as ReactComponent };